import React from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import QuoteBand from "@/components/QuoteBand";
import ServicesAndCalc from "@/components/ServicesAndCalc";
import PastWork from "@/components/PastWork";
import Footer from "@/components/Footer";

const LandingPage = () => {
  return (
    <main data-testid="landing-page" className="min-h-screen bg-[#f4f1ea]">
      <Header />
      <Hero />
      <ServicesAndCalc />
      <PastWork />
      <QuoteBand />
      <Footer />
    </main>
  );
};

export default LandingPage;
